/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AdminListingSeverity = {
    ListingSeverityOverpriced: 'overpriced',
    ListingSeverityNotCompetitive: 'not_competitive',
    ListingSeverityBelowFloor: 'below_floor',
    ListingSeverityStale: 'stale',
    ListingSeverityNoMarketData: 'no_market_data',
    ListingSeverityOk: 'ok'
} as const;
export type AdminListingSeverity = typeof AdminListingSeverity[keyof typeof AdminListingSeverity];


export function instanceOfAdminListingSeverity(value: any): boolean {
    for (const key in AdminListingSeverity) {
        if (Object.prototype.hasOwnProperty.call(AdminListingSeverity, key)) {
            if (AdminListingSeverity[key as keyof typeof AdminListingSeverity] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AdminListingSeverityFromJSON(json: any): AdminListingSeverity {
    return AdminListingSeverityFromJSONTyped(json, false);
}

export function AdminListingSeverityFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminListingSeverity {
    return json as AdminListingSeverity;
}

export function AdminListingSeverityToJSON(value?: AdminListingSeverity | null): any {
    return value as any;
}

export function AdminListingSeverityToJSONTyped(value: any, ignoreDiscriminator: boolean): AdminListingSeverity {
    return value as AdminListingSeverity;
}

